import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { first, shareReplay } from 'rxjs';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ReportsService } from 'src/app/services/reports.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-epc-estimation-details',
  templateUrl: './epc-estimation-details.component.html',
  styleUrls: ['./epc-estimation-details.component.scss'],
  providers: [DatePipe],
})
export class EpcEstimationDetailsComponent implements OnInit {
  @ViewChild('miPondTable', { static: true })
  public miPondTable: Table;

  public userId: any;
  public estimationTableData: any = [];
  public subscriptions: any = []
  public subjectSub: any;
  public loading: boolean = false;
  public ipAddress: any;
  public menuItems: MenuItem[];

  constructor(
    private service: BaseService,
    private activityRecordService: ActivityRecordService,
    private venodrDashBoardService: VendorDashboardService,
    private messageService: MessageService,
    private ipService: IpAddressService,
    private confirmationService: ConfirmationService,
    private loader: AppLoaderService,
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.loadData();

    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.estimationTableData, "EPC Estimation Details");
        }
      },
    ];
  }


  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  // loadDataAndApplyFilter() {
  //   if (sessionStorage.getItem('financialYear')) {
  //     this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
  //   }

  //   this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
  //     (res) => {
  //       this.selectedYear = res;
  //       this.loadData();
  //     }
  //   );
  // }

  loadData() {
    this.getIP();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    // this.loader.start();
    this.loading = true;
    let sub = this.venodrDashBoardService
      .getEstimationDetailsByUserIDEPC(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'EPC Estimation Details', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;
          // data = JSON.parse(data)
          if (data.length > 0) {
            this.estimationTableData = data.map((val) => ({
              ...val,
            }))
          }
          else {
            this.estimationTableData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'EPC Estimation Details', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }


  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App Id": d.AppId,
          "Outlets": d.Outlets,
          "Agreement No": d.AgreementNo,
          "Programme Name": d.Program_Name,
          "Chunk Id": d.ChunkId,
          "XEN Status": d.XEN_Status,
          "XEN Remarks": d.XEN_Remarks,
          "JE Status": d.JE_Status,
          "JE Remarks": d.JE_Remarks
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  refreshTable() {
    this.loadData();
  }

  rowBackgroundColor(row) {
    // if (row.Active == 1) {
    //   //light green
    //   return '#99e699'
    // }
    // else if (row.Active == 0) {
    //   //red
    //   return '#ff8080';
    // }
    // else 
    return '#ffffff';
  }
}


